import { expectEl, expectEls, expectGameContext, videoSrcOf } from "../util";
import { Scene, SceneVideo } from "../gameData";
import { addSceneElements } from "./addSceneElements";
import { runAction } from "./runAction";
import { removeSceneElements } from "./removeSceneElements";
import { updateNavBtns, playVideo } from "./videoControl";

export function playSceneVideo(scene: Scene) {
    const ctx = expectGameContext();
    ctx.gameState.state = "video";

    removeSceneElements();

    if (scene.video) {
        const videoEl = setVideoActive(scene.video);
        videoEl.setAttribute("data-video-type", "video");
        videoEl.loop = false;
        videoEl.onended = () => onVideoEnd(scene, videoEl);
    } else {
        onVideoEnd(scene);
    }

    playVideo();

    updateNavBtns();
}

function setVideoActive(video: SceneVideo): HTMLVideoElement {
    const videoSrc = `videos/${videoSrcOf(video)}`;

    const videoEls = expectEls<HTMLVideoElement>("#game .videos .video");
    videoEls.forEach(setVideoInactive);

    const targetVideoEl = expectEl<HTMLVideoElement>(
        `#game .videos .video[data-src="${videoSrc}"]`,
    );

    if (typeof video === "object" && video.style) {
        Object.assign(targetVideoEl.style, video.style);
    }

    targetVideoEl.classList.add("active");

    targetVideoEl.currentTime = 0;
    targetVideoEl.play();

    return targetVideoEl;
}

function setVideoInactive(videoEl: HTMLVideoElement) {
    videoEl.pause();
    videoEl.classList.remove("active", "visible");
    videoEl.onended = null;
}

function onVideoEnd(scene: Scene, videoEl?: HTMLVideoElement) {
    if (videoEl) {
        setVideoInactive(videoEl);
    }

    if (scene.loop) {
        const loopEl = setVideoActive(scene.loop);
        loopEl.setAttribute("data-video-type", "loop");
        loopEl.loop = true;
        loopEl.play();
    } else {
        if (videoEl) {
            videoEl.classList.add("visible");
            videoEl.currentTime = videoEl.duration - 0.01;
            videoEl.pause();
        }
    }

    if (scene.initialAction) {
        runAction(scene.initialAction);
    }

    const ctx = expectGameContext();

    if (ctx.gameState.currentSceneId === scene.id) {
        ctx.gameState.state = "input";
        addSceneElements(scene);
        updateNavBtns();
    }
}
